import React, { useEffect, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import * as modalDataService from './modalDataService';
import * as validationService from "./validationService";

function PowerCLIUsernameField({ powerCliUsername, centralCredential, error, disabled }) {

    const [disableValue, setDisableValue] = useState(disabled)

    useEffect(() => {
        validationService.validateUsername(powerCliUsername, 'powerCliUsername');
        return () => validationService.cleanValidation('powerCliUsername');
    }, [powerCliUsername])

    useEffect(() => {
        if(centralCredential && centralCredential.id > 0) {
            setDisableValue(true);
        }
        else {
            setDisableValue(false);
        }
        // validationService.validateUsername(sshUsername, 'sshUsername');
        // return () => validationService.cleanValidation('sshUsername');
    }, [centralCredential])

    const onChange = (value) => modalDataService.changePowerCLIUsername(value);

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="powercli_username">username</label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="powercli_username-key"
                    disabled={disableValue}
                    value={powerCliUsername}
                    onChange={event => onChange(event.target.value)} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("PowerCLIUsernameField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    return {
        powerCliUsername: addDeviceModal.powerCliUsername || '',
        centralCredential: addDeviceModal.centralCredential || null,
        error: validation.powerCliUsername,
    }
}

export default connect(mapStateToProps)(PowerCLIUsernameField);
